import React, { Component } from 'react'
import Footer from './Footer.jsx'

import './home/css/bootstrap.css'
import './home/css/fontawesome-all.css'
import './home/css/styles.css'
import "bootstrap/dist/css/bootstrap.min.css"

// import logo from './home/images/logo.png'

class MemberInfo extends Component {
  render() {
    return (
      <div>
        <header id="headerBlack" className="ex-header">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <h1>What is a Seatstir membership?</h1>
              </div>
            </div>
          </div>
        </header>
        <div>
          <br />
          <h2> Infographic will display here on how memberships are supposed to work</h2>
          <br />
        </div>

        <Footer />
      </div>
    )
  }
}

export default MemberInfo